import { useState } from "react";
import type { MovieReview } from "@/mocks/reviews";

interface ReviewSectionProps {
  reviews: MovieReview[];
}

function ReviewItem({ review }: { review: MovieReview }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <article className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center gap-3 mb-3">
        <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
          <i className="ri-user-3-line"></i>
        </span>
        <div className="min-w-0">
          <p className="text-sm font-medium text-foreground-900">{review.author}</p>
          <p className="text-xs text-foreground-500">{review.date}</p>
        </div>
        <span className="ml-auto flex items-center gap-1 text-xs text-primary-500 shrink-0">
          <i className="ri-heart-3-line"></i>
          {review.likes}
        </span>
      </div>

      <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 leading-snug">
        {review.title}
      </h3>

      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{review.excerpt}</p>

      {expanded && (
        <div className="mt-3 flex flex-col gap-3 border-t border-background-200 pt-3">
          {review.content.map((p, i) => (
            <p key={i} className="text-sm text-foreground-700 leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      )}

      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="mt-3 text-sm text-primary-600 hover:text-primary-700 cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        {expanded ? "收起全文" : "展开全文"}
        <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
      </button>
    </article>
  );
}

export default function ReviewSection({ reviews }: ReviewSectionProps) {
  return (
    <section>
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1 h-6 rounded-full bg-primary-500"></span>
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
          影评聚合
        </h2>
        <span className="text-sm text-foreground-500">共 {reviews.length} 篇</span>
      </div>

      {reviews.length === 0 ? (
        <div className="rounded-lg bg-background-50 border border-background-200 py-12 text-center">
          <i className="ri-chat-3-line text-4xl text-foreground-300"></i>
          <p className="mt-3 text-sm text-foreground-500">暂无影评，欢迎你来写下第一篇观后感</p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {reviews.map((r) => (
            <ReviewItem key={r.id} review={r} />
          ))}
        </div>
      )}
    </section>
  );
}